import { closeModel } from "./modal-toggle";
import { lenis } from "../lenis";

export function ambientModel() {
    const openBtns = document.querySelectorAll(".ma-open");
    const closeBtn = document.querySelector(".ma-close");
    const fullImageAmbient = document.querySelector(".full-image-ambient");

    // Create next/prev buttons dynamically in the modal
    const prevBtn = document.createElement("button");
    prevBtn.className = "modal-prev";
    prevBtn.innerHTML = "&#10094;"; // Left arrow

    const nextBtn = document.createElement("button");
    nextBtn.className = "modal-next";
    nextBtn.innerHTML = "&#10095;"; // Right arrow

    // Append buttons to modal container
    if (fullImageAmbient) {
        fullImageAmbient.appendChild(prevBtn);
        fullImageAmbient.appendChild(nextBtn);
    }

    let currentIndex = -1; // Track which image is active

    function showItem(index) {
        if (!fullImageAmbient) return;
        fullImageAmbient.innerHTML = ""; // Clear content

        // Add navigation buttons back
        fullImageAmbient.appendChild(prevBtn);
        fullImageAmbient.appendChild(nextBtn);

        const btn = openBtns[index];
        const datatype = btn.getAttribute("data-type");
        const dataUrl = btn.getAttribute("data-url");

        if (datatype === "video") {
            const video = document.createElement("video");
            video.src = dataUrl;
            video.controls = true;
            video.autoplay = true;
            video.muted = false;
            fullImageAmbient.appendChild(video);
        } else {
            const img = document.createElement("img");
            img.src = dataUrl;
            img.alt = "";
            fullImageAmbient.appendChild(img);
        }
    }

    if (openBtns.length) {
        openBtns.forEach((btn, index) => {
            btn.addEventListener("click", function () {
                closeModel();
                document.body.classList.add("model-active-ambient");
                lenis.stop();

                // Stop all videos outside modal
                document.querySelectorAll("video").forEach((video) => {
                    if (!video.paused) video.pause();
                });
                document.querySelectorAll(".js-playvideo.hide").forEach((btn) => btn.classList.remove("hide"));
                document.querySelectorAll(".js-pause-button").forEach((btn) => btn.classList.add("hide"));

                currentIndex = index;
                showItem(currentIndex);
            });
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            fullImageAmbient.innerHTML = "";
            closeModel();
            lenis.start();
        });
    }

    // Next/Prev navigation
    nextBtn.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % openBtns.length;
        showItem(currentIndex);
    });

    prevBtn.addEventListener("click", () => {
        currentIndex = (currentIndex - 1 + openBtns.length) % openBtns.length;
        showItem(currentIndex);
    });

    // Optional: Close modal on background click
    document.querySelector(".model-ambient-bg")?.addEventListener("click", () => {
        closeBtn.click();
    });
}
